import { alpha, styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import TextField from "@mui/material/TextField";

export const StyledTextField = styled(TextField)(({ theme, labelpadding }) => ({
  "& .MuiInputBase-root": {
    padding: "5px 10px",
    backgroundColor: grey["50"],
    borderRadius: "1.7rem",

    transition: "all 0.2s ease-in-out",
    border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,

    "&:hover": {
      backgroundColor: theme.palette.background.paper,
      borderColor: alpha(theme.palette.primary.main, 0.3),
    },
  },
  "& .MuiInputLabel-root": {
    padding: labelpadding ?? 0,
    color: grey["500"],
    fontWeight: 700,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {},
    "&:hover fieldset": {},
    "&.Mui-focused fieldset": {},
  },
}));
